<template>
  <blob-panel>
    <h1 class="text-center">
      Sign in
    </h1>
    <tabs :tabs="[{ id: 'login', title: 'Login'},{ id: 'sso', title: 'Single Sign-on'}]">
      <template slot="login">
        <form role="form" method="POST" :action="loginRoute">
          <input type="hidden" name="_token" :value="csrfToken">

          <div class="form-group" :class="{'has-error': emailError}">
            <label for="email">
              Email
            </label>
            <input
              id="email"
              type="email"
              class="form-control"
              name="email"
              :value="previousEmail"
              autocomplete="email"
              required
              autofocus
            >
            <span
              v-if="emailError"
              class="help-block"
            >
              <strong>{{ emailError }}</strong>
            </span>
          </div>

          <div class="form-group" :class="{'has-error': passwordError}">
            <label for="password">
              Password
            </label>
            <input
              id="password"
              type="password"
              class="form-control"
              name="password"
              autocomplete="password"
              required
            >

            <span
              v-if="passwordError"
              class="help-block"
            >
              <strong>{{ passwordError }}</strong>
            </span>
          </div>

          <div class="form-group">
            <div class="checkbox">
              <label>
                <input
                  type="checkbox"
                  name="remember"
                  :checked="previousStayLoggedIn"
                >
                Stay logged in
              </label>
            </div>
          </div>

          <div class="u-mt-x-large u-flex-row u-align-center">
            <button type="submit" class="btn btn--primary">
              Sign in
            </button>
            <a :href="passwordResetRoute" class="u-ml-x-large muted-link">
              Forgot your password?
            </a>
          </div>
        </form>
      </template>
      <template slot="sso">
        <form @submit="continueWithSlug">
          <label for="slug">
            Slug
          </label>
          <input
            id="slug"
            v-model="slug"
            type="text"
            class="form-control"
            placeholder="acme"
            minlength="3"
            maxlength="60"
            required
            pattern="[a-z0-9-]+"
          >
          <span class="help-block">
            Your slug is part of the url that comes after /login, e.g. blendr.io/login/<strong>acme</strong>
          </span>
          <div class="u-mt-x-large text-right">
            <button
              type="submit"
              class="btn btn--primary"
            >
              Continue
            </button>
          </div>
        </form>
      </template>
    </tabs>
  </blob-panel>
</template>

<script>
import doesBrowserSupportCookies from '../../functions/doesBrowserSupportCookies'

export default {
  props: ['loginRoute', 'passwordResetRoute', 'emailError', 'passwordError', 'previousStayLoggedIn', 'previousEmail'],

  data() {
    return {
      slug: null,
    }
  },

  computed: {
    csrfToken() {
      return window.Laravel.csrfToken
    },
  },

  beforeCreate() {
    if (!doesBrowserSupportCookies()) {
      window.location = '/sso/blocked-cookies'
    }
  },

  methods: {
    continueWithSlug(event) {
      event.preventDefault()
      window.location = '/login/' + this.slug
    },
  },
}
</script>
